module.exports = __webpack_public_path__ + "static/media/arrow-community.3fdca456.svg";